import Image1 from "../assets/images/thumb/image1.jpg";
import Image2 from "../assets/images/thumb/image2.jpg";
import Image3 from "../assets/images/thumb/image3.jpg";
import Image4 from "../assets/images/thumb/image4.jpg";


const mockVideos = [
    {
        id: "v1",
        title: "Itaú — Festival",
        subtitle: "Cobertura + storytelling + recorte social",
        url: "https://www.youtube.com/embed/ill07-45M4c?si=VU2M01ZrkZXL3jug",
        thumb: Image4,
    },
    {
        id: "v2",
        title: "Natura — Lançamento",
        subtitle: "Vídeo de lançamento de produto",
        url: "https://www.youtube.com/embed/ill07-45M4c?si=VU2M01ZrkZXL3jug",
        thumb: Image1,
    },
    {
        id: "v3",
        title: "Samsung — Evento",
        subtitle: "Cobertura completa do evento",
        url: "https://www.youtube.com/embed/ill07-45M4c?si=VU2M01ZrkZXL3jug",
        thumb: Image2,
    },
    {
        id: "v4",
        title: "Coca-Cola — Campanha",
        subtitle: "Vídeo para campanha publicitária",
        url: "https://www.youtube.com/embed/ill07-45M4c?si=VU2M01ZrkZXL3jug",
        thumb: Image3,
    },
    {
        id: "v5",
        title: "Itaú — Festival",
        subtitle: "Cobertura + storytelling + recorte social",
        url: "https://www.youtube.com/embed/ill07-45M4c?si=VU2M01ZrkZXL3jug",
        thumb: Image4,
    },
    {
        id: "v6",
        title: "Natura — Lançamento",
        subtitle: "Vídeo de lançamento de produto",
        url: "https://www.youtube.com/embed/ill07-45M4c?si=VU2M01ZrkZXL3jug",
        thumb: Image1,
    },
    {
        id: "v7",
        title: "Samsung — Evento",
        subtitle: "Cobertura completa do evento",
        url: "https://www.youtube.com/embed/ill07-45M4c?si=VU2M01ZrkZXL3jug",
        thumb: Image2,
    },
    {
        id: "v8",
        title: "Coca-Cola — Campanha",
        subtitle: "Vídeo para campanha publicitária",
        url: "https://www.youtube.com/embed/ill07-45M4c?si=VU2M01ZrkZXL3jug",
        thumb: Image3,
    },
    {
        id: "v9",
        title: "Xeque-Mate — Campanha",
        subtitle: "Vídeo para campanha publicitária",
        url: "https://www.youtube.com/embed/ill07-45M4c?si=VU2M01ZrkZXL3jug",
        thumb: Image2,
    },


];

export default mockVideos;